import withTracker from '.././withTracker';
import Subscribe from '../../containers/subscriber/Subscribe';

const subscribe = {
  path: '/subscribers/subscribe',
  component: withTracker(Subscribe)
};

export default subscribe;
